import { FieldList } from "@/components/fields/FieldList";
import { Button } from "@/components/ui/button";
import { HelpCircle, FileText } from "lucide-react";
import { Link } from "react-router";

const Fields = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Field Management</h1>
          <p className="text-muted-foreground">Create and manage fields for your datasets.</p>
        </div>
        <div className="flex gap-2">
          <Link to="/admin/fields/rules">
            <Button variant="outline" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Field Rules
            </Button>
          </Link>
          <Link to="/admin/fields/help-texts">
            <Button variant="outline" className="flex items-center gap-2">
              <HelpCircle className="h-4 w-4" />
              Manage Help Texts
            </Button>
          </Link>
        </div>
      </div>
      <FieldList />
    </div>
  );
};

export default Fields;
